import React from 'react';
import { useBeaconNavigator } from 'src/components/BeaconV2Components/BeaconNavigation/useBeaconNavigator';
import { validationSteps } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/constants';
import { usePresentationFormContext } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/PresentationFormContext';
import {
  PresentationsTab,
  PresentationsTabsPath
} from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/types';
import { GenericNavigationTabs } from 'src/components/BeaconV2Components/SubtabNav/SubtabNavigation';
import { useSnackbar } from 'src/utils/Hooks';

const PresentationsDisplayName = {
  type: 'Type',
  selections: 'Selections',
  brands: 'Brands',
  confirmation: 'Confirmation'
};

interface PresentationsNavigationTabsProps {
  tab: PresentationsTab;
}

export const PresentationsNavigationTabs = ({ tab }: PresentationsNavigationTabsProps) => {
  const { beaconNavigator } = useBeaconNavigator();
  const { isValidStep } = usePresentationFormContext();
  const { showSnackbar } = useSnackbar();

  const handleTabChange = (newTab: PresentationsTab, newPath: string) => {
    const validationStepsList = Object.keys(validationSteps);
    const newTabIndex = validationStepsList.findIndex((step) => step === newPath);

    for (let i = 0; i < newTabIndex; i++) {
      const isValid = isValidStep(validationStepsList[i] as PresentationsTabsPath);
      if (!isValid) {
        showSnackbar({ type: 'error', message: validationSteps[validationStepsList[i]].error });
        return;
      }
    }

    beaconNavigator.setPathname(newPath).go();
  };

  return (
    <GenericNavigationTabs
      tab={tab}
      tabs={[
        {
          label: PresentationsDisplayName.type,
          onClick: () => handleTabChange(PresentationsTab.Type, PresentationsTabsPath.type),
          value: PresentationsTab.Type
        },
        {
          label: PresentationsDisplayName.selections,
          onClick: () => handleTabChange(PresentationsTab.Selections, PresentationsTabsPath.selections),
          value: PresentationsTab.Selections
        },
        {
          label: PresentationsDisplayName.brands,
          onClick: () => handleTabChange(PresentationsTab.Brands, PresentationsTabsPath.brands),
          value: PresentationsTab.Brands
        },
        {
          label: PresentationsDisplayName.confirmation,
          onClick: () => handleTabChange(PresentationsTab.Confirmation, PresentationsTabsPath.confirmations),
          value: PresentationsTab.Confirmation
        }
      ]}
    />
  );
};
